// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"4b14f515","377":"7e58c938","548":"d8614e36","636":"2bcdc42f","881":"1e278c18","936":"59eb3866"}[chunkId] + ".chunk.css";
};